import { ResponseBase } from '@api/types';

export const AuthorizedUserPermissions = {
  Owner: 'Owner',
  Read: 'Read',
  Write: 'Write',
} as const;

export type AuthorizedUserPermission = 'Owner' | 'Read' | 'Write';

export type AuthorizedUser = {
  authorizedUserID: number;
  projectID: number;
  projectVersion: number;
  requestID: number;
  version: number;
  userID: number;
  firstName: string;
  lastName: string;
  email: string;
  permission: AuthorizedUserPermission;
  beginValid?: string | null;
  endValid?: string | null;
  role: string;
};

export type BatchAuthorizedUsersPayload = {
  add: Array<{
    userID: number;
    permission: AuthorizedUserPermission;
  }>;
  update: Array<{
    authorizedUserID: number;
    permission: AuthorizedUserPermission;
  }>;
  deactivate: number[];
  transferOwnership: number | null;
};

export type AuthorizedUserOperationError = {
  authorizedUserID: number;
  errorCode: string;
  message: string;
};

export type AuthorizedUserResponseData = {
  add: AuthorizedUserOperationError[];
  update: AuthorizedUserOperationError[];
  deactivate: AuthorizedUserOperationError[];
  transfer: Record<string, unknown>;
} | null;

export type BatchUpdateStatus = 'Success' | 'Partial Success' | 'Failed';

export type AuthorizedUserResponse = ResponseBase & {
  status: BatchUpdateStatus;
  msg: string;
  data: AuthorizedUserResponseData;
};

export type GetAuthorizedUsersResponseData = AuthorizedUser[];

export type GetAuthorizedUsersResponse = ResponseBase & {
  data: GetAuthorizedUsersResponseData;
};

export type getProjectOwnerAndCurrentUserPermissionsResponseData = AuthorizedUser[];

export type getProjectOwnerAndCurrentUserPermissionsResponse = ResponseBase & {
  data: GetAuthorizedUsersResponseData;
};
